<template>
  <v-dialog
    v-model="show"
    content-class="crud-dialog"
    persistent
    max-width="400px"
  >
    <v-card class="crud-card">
      <v-card-title class="crud-card-title">
        <v-row no-gutters>
          <v-col cols="11" class="text-left">
            <h2 class="text-h5">Choose asset</h2>
          </v-col>
          <v-col cols="1">
            <v-icon class="close" color="black" @click.stop="closeDialog">{{
              icons.mdiClose
            }}</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-divider />
      <v-card-text class="crud-card-text">
        <div v-if="!loading">
          <div v-if="hasProperties" class="asset-section">
            <h3>Properties</h3>
            <ChooseAssetSection
              :assets="testator.properties"
              asset-type="Property"
              :current-donation-asset-id="currentDonationAssetId"
              @assetChosen="assetChosen"
            />
          </div>

          <div v-if="hasVehicles" class="asset-section">
            <h3>Vehicles</h3>
            <ChooseAssetSection
              :assets="testator.vehicles"
              asset-type="Vehicle"
              :current-donation-asset-id="currentDonationAssetId"
              @assetChosen="assetChosen"
            />
          </div>

          <div v-if="hasFinancialAssets" class="asset-section">
            <h3>Investments</h3>
            <p class="legal-notice">
              Legally, <b>Pension Funds</b>, <b>Retirement Annuities</b>,
              <b>LIfe Insurance</b> and <b>Funeral Policies</b> cannot be
              bequeathed in a will, therefore, if you recorded any, they will
              not appear here.
            </p>
            <ChooseAssetSection
              :assets="donatableFinancialAssets"
              asset-type="FinancialAsset"
              :current-donation-asset-id="currentDonationAssetId"
              @assetChosen="assetChosen"
            />
          </div>

          <div v-if="hasOtherAssets" class="asset-section">
            <h3>Other Assets</h3>
            <ChooseAssetSection
              :assets="testator.otherAssets"
              asset-type="OtherAsset"
              :current-donation-asset-id="currentDonationAssetId"
              @assetChosen="assetChosen"
            />
          </div>

          <p v-if="noAssetsExist">
            You have not added any assets in the assets step yet
          </p>
        </div>

        <div v-else class="text-center">
          <v-progress-circular indeterminate color="primary" />
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import { TESTATOR_QUERY } from '../../constants/graphql/testators';
  import ChooseAssetSection from './ChooseAssetSection.vue';

  export default {
    name: 'ChooseAssetDialog',
    components: {
      ChooseAssetSection,
    },
    props: {
      value: Boolean,
      currentDonationAssetId: String,
    },
    data() {
      return {
        testator: {},
        loading: true,
      };
    },
    apollo: {
      testator: {
        query: TESTATOR_QUERY,
        variables() {
          return {
            id: this.testatorId,
          };
        },
        result(response) {
          if (response.data) this.loading = false;
        },
      },
    },
    computed: {
      show: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        },
      },
      hasProperties() {
        return this.testator.properties.length;
      },
      hasVehicles() {
        return this.testator.vehicles.length;
      },
      hasFinancialAssets() {
        return this.testator.financialAssets.length;
      },
      hasOtherAssets() {
        return this.testator.otherAssets.length;
      },
      donatableFinancialAssets() {
        return this.testator.financialAssets.filter(fa =>
          this.$options.donatableFinancialAssetTypes.includes(fa.investmentType)
        );
      },
      noAssetsExist() {
        return (
          !this.hasProperties &&
          !this.hasVehicles &&
          !this.hasFinancialAssets &&
          !this.hasOtherAssets
        );
      },
    },
    methods: {
      closeDialog() {
        this.$emit('dialogClosed');
      },
      assetChosen(asset, type) {
        asset.type = type;
        this.$emit('assetChosen', asset);
      },
    },
    donatableFinancialAssetTypes: [
      'CRYPTOCURRENCY',
      'FIXED_DEPOSIT',
      'SHARES',
      'SHAREHOLDING_IN_A_BUSINESS',
      'SAVINGS',
      'TAX_EXEMPT_INVESTMENT',
      'OTHER',
    ],
  };
</script>

<style lang="scss">
  .asset-section {
    margin-bottom: 20px;

    .legal-notice {
      font-size: 13px;
    }
  }
</style>
